import { useState } from 'react';
import { yearArchives } from '@/mocks/home';

export default function YearTimeline() {
  const [openYear, setOpenYear] = useState(yearArchives[0].year);

  return (
    <section id="timeline" className="scroll-mt-28 bg-primary-950 py-14 md:py-20">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="flex flex-col gap-5 border-b border-background-50/15 pb-8 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="font-label text-xs tracking-[0.24em] text-accent-400">
              TIMELINE / 历史存档
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-background-50 md:text-3xl">
              按年份进馆，一层层往下翻
            </h2>
            <p className="mt-3 font-body text-sm leading-7 text-background-200">
              历史存档按年份分区，每一区都写明收录期数和当年最值得重看的三条。点开年份即可展开，
              越往下越是年头久的旧账。
            </p>
          </div>
          <div className="flex items-center gap-2 rounded-lg border border-background-50/15 px-4 py-3">
            <i className="ri-calendar-2-line text-lg text-accent-400"></i>
            <div>
              <p className="font-heading text-sm font-bold text-background-50">存档共 5 个年份区</p>
              <p className="font-label text-[11px] text-background-300">最早回溯至 2016 年</p>
            </div>
          </div>
        </div>

        <div className="mt-8 divide-y divide-background-50/12 rounded-lg border border-background-50/12 bg-background-50/[0.04]">
          {yearArchives.map((zone) => {
            const isOpen = openYear === zone.year;
            return (
              <div key={zone.year}>
                <button
                  type="button"
                  onClick={() => setOpenYear(isOpen ? '' : zone.year)}
                  className="flex w-full cursor-pointer items-center gap-4 px-4 py-5 text-left transition-colors hover:bg-background-50/[0.05] md:gap-6 md:px-6"
                >
                  <span
                    className={`flex h-11 w-16 shrink-0 items-center justify-center rounded-md font-heading text-lg font-black tracking-tight md:w-24 md:text-2xl ${
                      isOpen ? 'bg-accent-500 text-foreground-950' : 'bg-background-50/10 text-background-100'
                    }`}
                  >
                    {zone.year}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="flex flex-wrap items-center gap-x-3 gap-y-1">
                      <span className="font-heading text-base font-bold text-background-50 md:text-lg">
                        收录 {zone.count} 期
                      </span>
                      <span className="rounded-full bg-background-50/10 px-2.5 py-0.5 font-label text-[11px] text-background-200">
                        {zone.note}
                      </span>
                    </p>
                    <p className="mt-1 font-body text-xs text-background-300 md:text-sm">
                      {isOpen ? '点击收起该年份的条目清单' : '点击展开该年份的往期条目'}
                    </p>
                  </div>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-background-50/20 text-background-100 transition-transform ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>

                {isOpen && (
                  <div className="anim-fade-in grid grid-cols-1 gap-3 px-4 pb-6 sm:grid-cols-2 md:grid-cols-3 md:px-6">
                    {zone.entries.map((entry) => (
                      <a
                        key={entry.title}
                        href="#archive"
                        className="group flex cursor-pointer items-start gap-3 rounded-md border border-background-50/12 bg-background-50/[0.03] p-4 transition-colors hover:border-accent-400/60 hover:bg-background-50/[0.08]"
                      >
                        <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary-500/90 text-background-50">
                          <i className="ri-file-list-3-line text-sm"></i>
                        </span>
                        <span className="min-w-0">
                          <span className="block font-body text-sm leading-6 text-background-100 transition-colors group-hover:text-accent-300">
                            {entry.title}
                          </span>
                          <span className="mt-1 block font-label text-[11px] text-background-400">
                            收录日期 {entry.date}
                          </span>
                        </span>
                      </a>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}